<template>
	<div class="page-container">
		<HeaderLayout></HeaderLayout>
		<div class="content">
			<h3 style='font-size:20px;padding-bottom:14px;'>1:1 문의</h3>
			<form  id="boardForm"  novalidate @submit="formSubmit">
				<div class="from-box">
					<table border="0" cellpadding="0" cellspacing="0">
						<tbody>
						<tr class="form-group">
							<th>제목</th>
							<td>
								<input type="text" placeholder="제목을 입력해주세요" required  name="subject" id="subject"/>
								<div class="md-error-box" style="margin-top:5px;">제목을 입력하세요</div>
							</td>
						</tr>
						
						<tr class="form-group">
							<th>문의내용</th>
						
							<td>
								<textarea  required style="text-align:left;" placeholder="문의내용을 입력해주세요"  name="contents" id="contents"></textarea>
								<div class="md-error-box" style="margin-top:5px;">문의내용을 입력하세요</div>
							</td>
						</tr>
						<tr class="form-group" id="logoTr">
					 		<th>첨부파일</th>
							<td class="pcs-box">   
								<div class="button-box">
									<md-button class="md-dense"  style='width:100%;margin:0;background:#fff;' type="button">찾아보기</md-button>
									<input type='file' id="dfileInput" accept="image/*">
								</div>
								<div class="button-box2" v-if="imgs.length>0">
									<md-button class="md-dense"  style='width:100%;margin:0;background:#fafafa;' type="button">추가하기</md-button>
									<input type='file' id="img" accept="image/*">
								</div>
								<input type="text" readonly  id="dfileView"/>
								<div class="box-bottom">
								   파일은 jpg, png, gif 등 이미지만 첨부가 가능합니다. (5mb 제한)
								</div>
								<div class="preview-layout" style='display:none'>
									<div class="swiper-container">
										<swiper  :options="swiperOption" ref="mySwiper">
											<swiper-slide v-for="img,index in imgList">
												
												<div>
													<span @click="removeImg(index)"><i class="fa fa-times"></i></span>
													<img :src="img"/>
												</div>
											</swiper-slide>
										</swiper>
									</div>
								</div>
							</td>
						</tr>
						</tbody>
					</table>
					<div class="button-box" style='width:70%;height:60px;margin:50px auto 90px auto;'>
						<md-button class="md-raised md-accent"	 style='border:none;padding:0;border-radius:none;width:30%;margin:0;background:#A8A8A8;height:45px;float:left;font-size:12pt;' @click="$router.go(-1)" type="button">취소</md-button>
						<md-button class="md-raised md-primary"	 style='border:none;padding:0;border-radius:none;width:60%;margin:0;height:45px;float:right;font-size:12pt;' type="submit">등록하기</md-button>
					</div>
					<div style="clear:both;"></div>
				</div>
			</form>
		</div>
		<FooterLayout></FooterLayout>
	</div>	
</template>


<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
   name: 'BoardWrite',
   components: {
	  swiper,
	  swiperSlide,
  	  HeaderLayout,
	  FooterLayout

   },
   computed: {
      swiper() {
    	return this.$refs.mySwiper.swiper
      }
   },
	data () {
		return {
			login:false,
			memberInfo:{},
			mcode:'board',
			bid:'',
			imgs:[],
			imgList:[],
			title:'1:1문의',
			swiperOption: {
				slidesPerView:'auto',
				freeMode:true
			}
		}
	},
	created() {
		
		this.bid = this.$route.params.bid;
	
	},
	methods: {

		formSubmit(e) {
			var $f = $('#boardForm');
			var formData1 = this.$form.validateOnly($f);
			if(formData1) {
				var formData = new FormData();
				if(this.imgs.length>0) {
					for(var key in this.imgs) { 
						formData.append('imgs[]',this.imgs[key]);			
					}
				}
				formData.append("bid",this.bid);
				for(var key in formData1) {
					formData.append(key,formData1[key]);
				}
				var obj = this;
				$.ajax({
				    url: this.$VARS.url+'boardProc/insertData',
				    processData: false,
				    contentType: false,
				    headers: {
					   "memberkey":sessionStorage.getItem('memberkey'),
					   "devToken":this.$VARS.devToken, 
					},
					data: formData,
				    type: 'POST',
					dataType:'json',
				    success: function(response){
						console.log(response);
						if(response.result=='fail') {
							alert(response.msg);	
						} else {
							var params = {};
							params.content = '1:1 문의가 등록되었습니다';	
						    params.doAction = function() {
								var url = '/board/question';
								obj.$router.push({path:url});
							}
							obj.$eventBus.$emit('dialogOpen',params);
							

						}
					},
					error:function(request,status,error){
						console.log("code:"+request.status+"\n"+"message:"+request.responseText+"\n"+"error:"+error);
					}
				});
			}
			e.preventDefault();
		
		
	  },
	  alertMessage() {
			var params = {};
			params.content = '이미지 최대개수는 3개 입니다';
			this.$eventBus.$emit('dialogOpen',params);		
	  },
	  removeImg(index) {
			this.imgs.splice(index,1)
			this.imgList.splice(index,1)
			if(this.imgs.length<1) {
				$('#dfileView').val('');
				$('.preview-layout').hide();
			}
			
	  }
	},
	mounted: function() {
		var file = document.querySelector('#dfileInput');
		var obj = this;
		file.onchange = function() {
			if(obj.imgs.length>0)return;
			
			var fileList = file.files;
			obj.imgs.push(fileList[0]);
				
			$('#dfileView').val(fileList[0].name);
			obj.$form.tempImage(fileList[0],function(img) { 
				obj.imgList.push(img);
				$('#img').val('');
			});
		}
		
	
	},
	updated() {
		if(this.imgs.length>0) {
			$('.preview-layout').show();

			var obj = this;
			var file = document.querySelector('#img');
			file.onchange = function() {
				if(!$('#img').val())return;
				if(obj.imgs.length>2) {
					obj.alertMessage()	
					$('#img').val('');
				} else {
					var fileList = file.files;
					obj.imgs.push(fileList[0]);
				
					obj.$form.tempImage(fileList[0],function(img) { 
						obj.imgList.push(img);
						$('#img').val('');
					});

				}
			}
		}
    }

}
</script>

<style lang="scss" scoped>

.preview-layout {
	width:100%;
	height:170px;
	padding:7px;
	.no-img {
		position:absolute;
		color:#f00;
		padding-left:5px;
		top:-15px;
		cursor:pointer;
	}
	.swiper-container {
		margin:0;
		padding:0;
		.swiper-slide {
			width:40%;
			margin:0 7px;
			position:relative;
			div {
				padding:10px 0 0 0;
				height:150px;
				overflow:hidden;
				span {
					z-index:300;
					position:absolute;
					right:-10px;
					top:0;
					display:inline-block;
					width:24px;
					height:24px;
					border-radius:12px;
					border:solid 1px #dcdcdc;
					background:#fff;
					color:#dcdcdc;
					text-align:center;
					line-height:24px;
					i {
						font-size:8pt;
					}
				}
			}
		}
		
	}
}
.page-container {
   width:100%;
   height:auto;
   background:#fff;
	.content {
		width:830px;
		margin:auto;
		background:#fff;
		padding-top:130px;
		.from-box {
			text-align:left;
			padding:10px 0;
			border-top:solid 2px #3D79FF;
			border-bottom:solid 1px #ccc;
			width:100%;
			margin:auto;
			table {
				width:100%;
				tr {
					th {
						width:140px;
						color:#999;
						line-height:60px;
						height:60px;
						font-size:12pt;
						font-weight:normal;
						border-bottom:solid 1px #DCDCDC;
					}
					td {
						padding:9px 0;
						border-bottom:solid 1px #DCDCDC;
						input {
							width:50%;
							background:#F4F4F4;
							height:42px;
							border:none;
							padding-left:10px;
						}
						select  {
							width:50%;
							background:#fff;
							height:40px;
							border:solid 1px #dfdfdf;
						}
						input:focus {
							border:solid 1px #444;
							outline:none;
						}
						select:focus {
							border:solid 1px #444;
							outline:none;
						}
						textarea {
							width:100%;
							background:#F4F4F4;
							height:200px;
							border:none;
							padding:10px;
						}
						textarea:focus {
							border:solid 1px #444;
							outline:none;
						}
						
						

					}
					td.pcs-box {
						position:relative;
						.button-box {
							width:100px;
							position:absolute;
							right:50%;
							.md-button {
								border-radius:none;
								border:solid 1px #777;
								height:41px;
							}
							#dfileInput {
								position:absolute;
								z-index:10;
								top:0;
								left:0;
								width:100%;
								height:41px;
								cursor:pointer;
								opacity:0;
								cursor:pointer;
							}
						}
						.button-box2 {
							width:100px;
							position:absolute;
							right:230px;
							.md-button {
								border-radius:none;
								border:solid 1px #777;
								height:41px;
								
							}
							#img {
								position:absolute;
								z-index:10;
								top:0;
								left:0;
								width:100%;
								height:41px;
								cursor:pointer;
								opacity:0;
								cursor:pointer;
							}
						}
						.box-bottom     {
							 color:#CBCBCB;
							 font-size:12px;
						 }
						
					}
				}
			}
			
			
		}
	}
}
</style>